<template>
  <b-container>
    <b-row>
      <b-col>
        <b-form-group
          label-cols="2"
          label="Is Active"
          label-class="pt-0">
          <b-form-checkbox v-model="message.isActive" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Type"
          label-class="pt-0">
          <b-form-input v-model="message.type" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Auto Dismiss"
          label-class="pt-0">
          <b-form-input v-model="message.autoDismiss" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Delay"
          label-class="pt-0">
          <b-form-input v-model="message.delay" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Targeted User Type"
          label-class="pt-0">
          <b-radio-group
            v-model="message.targetedUserType">
            <b-form-radio value="free">
              Free
            </b-form-radio>
            <b-form-radio value="paid">
              Paid
            </b-form-radio>
          </b-radio-group>
        </b-form-group>
        <b-row>
          <b-col class="category">
            Toaster
          </b-col>
        </b-row>
        <b-form-group
          label-cols="2"
          label="Button Link Url"
          label-class="pt-0">
          <b-form-input v-model="message.buttonLinkUrl" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Button Label"
          label-class="pt-0">
          <b-form-input v-model="message.buttonLabel" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Link New Window"
          label-class="pt-0">
          <b-form-checkbox v-model="message.linkNewWindow" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Body"
          label-class="pt-0">
          <b-form-input v-model="message.body" />
        </b-form-group>
        <b-row>
          <b-col class="category">
            Modal
          </b-col>
        </b-row>
        <b-form-group
          label-cols="2"
          label="Is Modal"
          label-class="pt-0">
          <b-form-checkbox v-model="message.isModal" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Template"
          label-class="pt-0">
          <b-form-input v-model="message.template" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Title"
          label-class="pt-0">
          <b-form-input v-model="message.title" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Subtitle"
          label-class="pt-0">
          <b-form-input v-model="message.subtitle" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Description"
          label-class="pt-0">
          <b-form-input v-model="message.description" />
        </b-form-group>
        <b-row>
          <b-col class="category">
            Link
          </b-col>
        </b-row>
        <b-form-group
          label-cols="2"
          label="Target"
          label-class="pt-0">
          <b-form-input v-model="message.link.target" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Text"
          label-class="pt-0">
          <b-form-input v-model="message.link.text" />
        </b-form-group>
        <b-row>
          <b-col class="category">
            Button
          </b-col>
        </b-row>
        <b-form-group
          label-cols="2"
          label="Action"
          label-class="pt-0">
          <b-form-input v-model="message.button.action" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Color"
          label-class="pt-0">
          <b-form-input v-model="message.button.style.color" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Background Color"
          label-class="pt-0">
          <b-form-input v-model="message.button.style.backgroundColor" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Padding"
          label-class="pt-0">
          <b-form-input v-model="message.button.style.padding" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Link New Window"
          label-class="pt-0">
          <b-form-checkbox v-model="message.button.linkNewWindow" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Label"
          label-class="pt-0">
          <b-form-input v-model="message.button.label" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Link"
          label-class="pt-0">
          <b-form-input v-model="message.button.link" />
        </b-form-group>
        <b-form-group
          label-cols="2"
          label="Icon Name"
          label-class="pt-0">
          <b-form-input v-model="message.button.iconName" />
        </b-form-group>
        <b-row>
          <b-col class="category">
            Marketing
          </b-col>
        </b-row>
        <b-form-group
          label-cols="2"
          label="Delay Between"
          label-class="pt-0">
          <b-form-input v-model="message.delayBetween" />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "MessageKey",
  props: {
    message: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.category {
  color: #333333;
  font-weight: bold;
  font-size: 16px;
}
</style>